<template>
  <div class="document">
    <h2>{{ msg }}</h2>
    <h3>Client entrance</h3>
    <ul>
      <img src="../assets/WebClient.png" alt="" style="width: 20px;height: 20px">
      <li><a :href="hostname+'/WebClient/' " rel="noopener">Web</a></li>
    </ul>
    <h3>Document entrance</h3>
    <ul>
      <img src="../assets/Document.png" alt="" style="width: 20px;height: 20px">
      <li><a :href="hostname+'/docs/'"  rel="noopener">Document</a></li>
    </ul>

     <h3>CmsApi entrance</h3>
    <ul>
      <img src="../assets/CmsApi.png" alt="" style="width: 20px;height: 20px">
      <li><a :href="hostname+'/CmsApi/'"  rel="noopener">CmsApi</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WebClient_Document',
 data(){
 // 获取当前是否为 HTTPS 协议
 const isHttps = location.protocol === 'https:';

return {
  // 如果是 https，使用 6063 端口；否则(http) 使用 6061 端口
  hostname: isHttps 
    ? 'https://' + location.hostname + ':6063' 
    : 'http://' + location.hostname + ':6061'
}
 },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img{
  margin: 0 10px -5px;
}

</style>
